import { DefaultOptionType } from "antd/es/select";

export const filterOption = (
  rawInput: string,
  option?: DefaultOptionType,
) => {
  const input = rawInput.toLocaleLowerCase();
  const candidateLabel = option?.label?.toString().toLocaleLowerCase() ?? "";
  return (
    candidateLabel.includes(input)
  );
};
